// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".c-form-error .c-validation-message{position:relative;white-space:normal}", "",{"version":3,"sources":["/usr/src/app/src/components/FormError/FormError.scss"],"names":[],"mappings":"AAEI,oCACI,iBAAA,CAEA,kBAAA","file":"FormError.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.c-form-error {\n    .c-validation-message {\n        position: relative;\n\n        white-space: normal;\n    }\n}\n"]}]);
// Exports
module.exports = exports;
